// Supabase service for HKDSE Flash Cards
// Replaces hkdseFlashCardsData.js imports

import { querySupabase } from '../supabaseClient';

/**
 * Get flash cards by text ID
 */
export const getHKDSEFlashCardsByTextId = async (textId) => {
  try {
    const records = await querySupabase('chi_hkdseflashcards', { text_id: textId }, {
      order_by: 'card_id',
      order_direction: 'asc'
    });
    
    if (!records || records.length === 0) return null;
    
    // Transform Supabase records to component-friendly format
    const firstRecord = records[0];
    const cards = records.map(record => ({
      id: record.card_id,
      front: record.card_front,
      back: record.card_back,
      category: record.card_category,
      difficulty: record.card_difficulty
    }));
    
    return {
      id: firstRecord.flashcard_set_id,
      textId: firstRecord.text_id,
      title: firstRecord.set_title,
      category: firstRecord.set_category,
      description: firstRecord.set_description,
      totalCards: firstRecord.total_cards,
      cards
    };
  } catch (error) {
    console.error('Error fetching flash cards:', error);
    return null;
  }
};

/**
 * Get flash cards by category
 */
export const getHKDSEFlashCardsByCategory = async (category) => {
  try {
    const records = await querySupabase('chi_hkdseflashcards', { set_category: category }, {
      order_by: 'flashcard_set_id',
      order_direction: 'asc'
    });
    
    if (!records || records.length === 0) return [];
    
    // Group by flashcard_set_id
    const setMap = {};
    records.forEach(record => {
      if (!setMap[record.flashcard_set_id]) {
        setMap[record.flashcard_set_id] = {
          id: record.flashcard_set_id,
          textId: record.text_id,
          title: record.set_title,
          category: record.set_category,
          description: record.set_description,
          totalCards: record.total_cards,
          cards: []
        };
      }
      setMap[record.flashcard_set_id].cards.push({
        id: record.card_id,
        front: record.card_front,
        back: record.card_back,
        category: record.card_category,
        difficulty: record.card_difficulty
      });
    });
    
    return Object.values(setMap);
  } catch (error) {
    console.error('Error fetching flash cards by category:', error);
    return [];
  }
};

/**
 * Get flash cards by difficulty
 */
export const getHKDSEFlashCardsByDifficulty = async (difficulty) => {
  try {
    const records = await querySupabase('chi_hkdseflashcards', { card_difficulty: difficulty }, {
      order_by: 'flashcard_set_id',
      order_direction: 'asc'
    });
    
    if (!records || records.length === 0) return [];
    
    // Group by flashcard_set_id (same logic as category)
    const setMap = {};
    records.forEach(record => {
      if (!setMap[record.flashcard_set_id]) {
        setMap[record.flashcard_set_id] = {
          id: record.flashcard_set_id,
          textId: record.text_id,
          title: record.set_title,
          category: record.set_category,
          description: record.set_description,
          totalCards: record.total_cards,
          cards: []
        };
      }
      setMap[record.flashcard_set_id].cards.push({
        id: record.card_id,
        front: record.card_front,
        back: record.card_back,
        category: record.card_category,
        difficulty: record.card_difficulty
      });
    });
    
    return Object.values(setMap);
  } catch (error) {
    console.error('Error fetching flash cards by difficulty:', error);
    return [];
  }
};

/**
 * Shuffle flash cards array
 */
export const shuffleFlashCards = (cards) => {
  const shuffled = [...cards];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

/**
 * Group flash cards by category
 */
export const groupFlashCardsByCategory = (cards) => {
  return cards.reduce((acc, card) => {
    const category = card.category || '其他';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(card);
    return acc;
  }, {});
};

